import { DropDownList } from "@progress/kendo-react-dropdowns";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
  GridCell,
} from "@progress/kendo-react-grid";
import { Input } from "@progress/kendo-react-inputs";
import React, { useEffect } from "react";
import { useRef } from "react";
import { deleteQuotation } from "./InvoiceBidDetailsServices";
import { process } from "@progress/kendo-data-query";
import { toast } from "react-toastify";
import {NumericFormat} from "react-number-format";

function InvoiceBidTable({
  props,
  currencySelected,
  setBlocking,
  toast,
  unitType,
  feeCodeData,
  passThroughFeeCodeData,
  tableData,
  result,
  setResult,
  dataState,
  setDataState,
  getAllQuotation,
  currentComponent,
  status,
  isEditClicked,
  setIsAddFeeCodeClicked,
  isCreaedUserDifferentFromLoggedInUserAtStatus10,
  tor_Type,
  buttonType,
  userRole = ''
}) {
  useEffect(() => {
    if (result.data.length > 0) {
      sessionStorage.setItem("isDataPresentinBidTable", JSON.stringify(true));
    } else {
      sessionStorage.setItem("isDataPresentinBidTable", JSON.stringify(false));
    }
  }, [result]);

  const { tor_id } = props;
  let editField = "inEdit";
  let grid = useRef(null);

  const itemChange = (event) => {
    const data = result.data.map((item) =>
      item.id === event.dataItem.id
        ? { ...item, [event.field]: event.value }
        : item
    );
    setResult(process(data, dataState));
  };

  const addNew = () => {
    const newDataItem = {
      inEdit: true,
      Discontinued: false,
      feeCodeData: null,
      id: Math.floor(Math.random() * 10000000),
    };
    setIsAddFeeCodeClicked(true);
    setResult(process([newDataItem, ...result.data], dataState));
  };

  const deleteFeeCode = async ({ dataItem }) => {
    if (isAddFeeDeleteCodeSaveBtnDisabled()) return;
    if (isCreaedUserDifferentFromLoggedInUserAtStatus10) return;

    if (dataItem["inEdit"] || buttonType === 'copy Quotation') {
      setResult(
        process(
          result.data.filter((r) => r["id"] !== dataItem["id"]),
          dataState
        )
      );
    } else {
      setBlocking(true);
      let resultArray = [];
      let resultObj = {};
      // resultObj["orderType"] = "ZSSB";
      resultObj["orderType"] = dataItem.orderType;
      resultObj["id"] = dataItem.id;
      resultObj["foNum"] = tor_id;
      resultObj["rfqNum"] = 
        typeof dataItem.rfqNum !== 'undefined' ? 
        dataItem.rfqNum.split('').slice(10,dataItem.rfqNum.length).join('') : 
        "";
      resultObj["quotationNum"] = "";
      // resultObj["docType"] = "QUOTE";
      resultObj["docType"] = dataItem.docType;
      resultObj["feeCode"] = dataItem.feeCode;
      resultObj["contracted"] = "";
      resultObj["tariffType"] = "";
      resultObj["units"] = "";
      resultObj["ratePerUnit"] = "";
      resultObj["chargeAmount"] = "";
      resultObj["comments"] = "";
      resultObj["tpt"] = ""; //QuotationService.tpt;
      resultObj["currencyCode"] = ""; //QuotationService.currency;
      resultObj["stopDateFlag"] = "";
      resultObj["dateFrom"] = "";
      resultObj["timeFrom"] = "";
      resultObj["timeFromZone"] = "";
      resultObj["dateTo"] = "";
      resultObj["timeTo"] = "";
      resultObj["timeToZone"] = "";
      resultObj["createdBy"] = "";
      resultArray.push(resultObj);
      var finalObj = {};
      finalObj["action"] = "DEL";
      finalObj["InputList"] = resultArray;
      let response = await deleteQuotation(finalObj);
      setBlocking(false);
      if (response[0]["statusType"] === "S") {
        await getAllQuotation();
        setResult(
          process(
            result.data.filter((r) => r["id"] !== dataItem["id"]),
            dataState
          )
        );
        toast.success("Charge deleted Successfully");
        setBlocking(false);
      } else {
        toast.error("Error in Deleting charges");
        setBlocking(false);
      }
    }
  };

  const onDataStateChange = (event) => {
    setDataState(event.dataState);
    setResult(
      process(
        tableData.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        ),
        event.dataState
      )
    );
  };

  const MyFeeCodeCell = (props) => (
    <FeeCodeCell
      {...props}
      feeCodeData={feeCodeData}
      passThroughFeeCodeData={passThroughFeeCodeData}
      currentComponent={currentComponent}
    />
  );

  const MyChargeDescriptionCell = (props) => (
    <ChargeDescriptionCell
      {...props}
      feeCodeData={feeCodeData}
      passThroughFeeCodeData={passThroughFeeCodeData}
      currentComponent={currentComponent}
    />
  );

  const MyContractedCell = (props) => (
    <ContractedCell {...props} contractArray={["Y", "N"]} />
  );

  const MyTariffTypeCell = (props) => (
    <TariffTypeCell {...props} unitType={unitType} />
  );

  const MyQuantityCell = (props) => (
    <QuantityCell
      {...props}
      currentComponent={currentComponent}
      status={status}
    />
  );

  const MyChargePerUnitCell = (props) => (
    <ChargePerUnitCell
      {...props}
      currentComponent={currentComponent}
      status={status}
    />
  );

  const MyTotalPriceCell = (props) => (
    <TotalPriceCell {...props} currencySelected={currencySelected} />
  );

  const MyCurrencyCell = (props) => (
    <CurrencyCell {...props} currencySelected={currencySelected} />
  );

  const CommandCell = (props) => {
    if (currentComponent === "bid" && status === 35 && buttonType === 'copy Quotation') {
      return (
        <td className="k-command-cell invoiceBid-delete">
          <span
            class="k-icon k-i-delete k-i-trash color-blue"
            onClick={() => deleteFeeCode(props)}
          ></span>
        </td>
      );
    } else if (currentComponent === "bid" && status > 10) {
      return <td></td>;
    } else if (currentComponent === "invoice" && status > 70 && status != 73) {
      return <td></td>;
    } else if (
      currentComponent === "invoice" &&
      status === 70 &&
      !props.dataItem.inEdit
    ) {
      return <td></td>;
    } else if (
      currentComponent === "invoice" &&
      status === 73 &&
      props.dataItem.sendBack == "N"
    ) {
      return (
        <td className="k-command-cell invoiceBid-delete">
          <span
            class={
              isAddFeeDeleteCodeSaveBtnDisabled()
                ? "k-icon k-i-delete k-i-trash color-gray"
                : "k-icon k-i-delete k-i-trash color-blue"
            }
            onClick={() => deleteFeeCode(props)}
          ></span>
        </td>
      );
    } else if (
      currentComponent === "invoice" &&
      status === 73 &&
      props.dataItem.sendBack == "Y"
    ) {
      return <td></td>;
    } else {
      return (
        <td className="k-command-cell invoiceBid-delete">
          <span
            class={
              isAddFeeDeleteCodeSaveBtnDisabled()
                ? "k-icon k-i-delete k-i-trash color-gray"
                : "k-icon k-i-delete k-i-trash color-blue"
            }
            onClick={() => deleteFeeCode(props)}
          ></span>
        </td>
      );
    }
  };

  const MyCommentCell = (props) => <CommentCell {...props} />;

  function showAddFeeCode() {
    if (currentComponent === "bid" && status == 10) {
      return true;
    } else if (
      currentComponent === "invoice" &&
      (status == 70 || status == 73)
    ) {
      return true;
    } else if (currentComponent === "invoice" && status == 10) {
      return true;
    } else if (currentComponent === "bid" && status == 35) {
      return true;
    } else if (currentComponent === "invoice") return false;
  }

  function isAddFeeDeleteCodeSaveBtnDisabled() {
    // console.log("isAddFeeDeleteCodeSaveBtnDisabled");
    // console.log(isCreaedUserDifferentFromLoggedInUserAtStatus10);
    // console.log(tableData !== null);
    // console.log(buttonType);
    // console.log(isEditClicked);
    // console.log(tableData.length);
    // console.log(userRole);
    // status is 10 type of user is GB login and different user tring to edit this, 
    // causing problem 
    if (isCreaedUserDifferentFromLoggedInUserAtStatus10) {
      if (userRole === 'CW') {} 
      else return true;
    }
    if (tableData !== null) {
      if (currentComponent === "invoice") {
        if (tor_Type == "ZEXC" && status === 10) {
          // IAR flow
          if (tableData.length && !isEditClicked) return true;
        }
        if (tor_Type == "ZEXC" && status > 10) {
          // IAR flow
          return true;
        }
        return false;
      }
      if (buttonType === "copy Quotation") return false;
      if (tableData.length && !isEditClicked) return true;
      return false;
    }
  }

  return (
    <>
      <div className="bidDetails-tabel-label">
        <label>Freight Charges</label>
      </div>

      <div className="bidDetails-tabel">
        <Grid
          ScrollMode="scrollable"
          style={{ maxHeight: "550px" }}
          data={result}
          pageable
          {...dataState}
          total={result.length}
          // filterable
          onDataStateChange={onDataStateChange}
          reorderable
          onItemChange={itemChange}
          editField={editField}
          ref={(g) => {
            grid = g;
          }}
        >
          <GridToolbar>
            {showAddFeeCode() && (
              <button
                title="Add new"
                className="k-button k-primary" style={{padding:'7px'}}
                onClick={addNew}
                disabled={isAddFeeDeleteCodeSaveBtnDisabled()}
              >
                Add Fee Code
              </button>
            )}
          </GridToolbar>
          <Column cell={CommandCell} width="50px" filterable={false} />
          <Column
            field="feeCode"
            title="Fee Code"
            cell={MyFeeCodeCell}
            width="100px"
          />
          <Column
            field="chargeDescription"
            title="Charge Description"
            cell={MyChargeDescriptionCell}
            width="200px"

          />
          <Column
            field="contractedYN"
            title="Contracted Y/N"
            cell={MyContractedCell}
            width="180px"
          />
          <Column
            field="tariffType"
            title="Tariff Type"
            width="150px"
            cell={MyTariffTypeCell}
          />
          <Column
            field="quantity"
            title="Quantity"
            cell={MyQuantityCell}
            width="150px"
          />
          <Column
            field="chargePerUnit"
            title="Charge Per Unit"
            width="200px"
            cell={MyChargePerUnitCell}
          />
          <Column
            field="totalPrice"
            title="Total Price"
            width="150px"
            cell={MyTotalPriceCell}
          />
          <Column
            field="currency"
            title="Currency"
            width="100px"
            cell={MyCurrencyCell}
          />
          <Column field="comments" title="Comments" cell={MyCommentCell} />
        </Grid>
      </div>
    </>
  );
}

class CommentCell extends (GridCell, React.Component) {
  state = {
    input: null,
  };

  handleChange(e) {
    this.setState({ input: e.target.value });
  }

  handleBlur(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.input,
    });
    this.setState({ input: "" });
  }

  render() {
    const { inEdit, comments } = this.props.dataItem;

    return (
      <td>
        {inEdit ? (
          <Input
            style={{ width: "inherit" }}
            onChange={this.handleChange.bind(this)}
            onBlur={this.handleBlur.bind(this)}
            value={
              this.state.input === null
                ? this.props.dataItem["comments"]
                : this.state.input
            }
          />
        ) : (
          comments
        )}
      </td>
    );
  }
}

class CurrencyCell extends (GridCell, React.Component) {
  componentDidMount() {}

  render() {
    const { inEdit, currency } = this.props.dataItem;
    return (
      <td>{inEdit ? this.props.currencySelected["currCode"] : currency}</td>
    );
  }
}

class TotalPriceCell extends (GridCell, React.Component) {
  componentDidMount() {}

  render() {
    const { chargePerUnit, quantity } = this.props.dataItem;
    const currencySelected = this.props.currencySelected.currCode;
    // For !== "JPY" slice no after 2 dec
    // For === "JPY" round of for 0 dec
    const totalPrice =
      currencySelected !== "JPY"
        ? parseFloat(chargePerUnit) * parseFloat(quantity)
        : parseFloat(
            (parseFloat(chargePerUnit) * parseFloat(quantity)).toFixed(0)
          );

    return (
      <td>
        {totalPrice ? (
          <NumericFormat
            value={!isNaN(totalPrice) ? totalPrice : ""}
            displayType={"text"}
            thousandSeparator={true}
            decimalSeparator={currencySelected !== "JPY" ? "." : ""}
            decimalScale={currencySelected !== "JPY" ? "2" : "0"}
            fixedDecimalScale={currencySelected !== "JPY" ? "true" : "false"}
          />
        ) : (
          ""
        )}
      </td>
    );
  }
}

class ChargePerUnitCell extends (GridCell, React.Component) {
  state = {
    input: null,
  };

  handleChange(e) {
    this.setState({ input: e.target.value });
  }

  handleBlur(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.input,
    });
    if (e.target.value <= 0) {
      toast.error("Unit Price Value must be greater then 0");
      return;
    }
    this.setState({ input: "" });
  }

  render() {
    const { inEdit, chargePerUnit } = this.props.dataItem;
    const { currentComponent, status } = this.props;
    if (
      (currentComponent === "invoice" &&
        status == 73 &&
        this.props.dataItem.sendBack == "N") ||
      inEdit
    ) {
      return (
        <td>
          <NumericFormat
            style={{ width: "80px" }}
            className="some k-textbox"
            inputmode="numeric"
            decimalSeparator="."
            decimalScale="2"
            fixedDecimalScale="true"
            onChange={this.handleChange.bind(this)}
            onBlur={this.handleBlur.bind(this)}
            value={
              this.state.input === null
                ? this.props.dataItem["chargePerUnit"]
                : this.state.input
            }
          />
        </td>
      );
    } else {
      return (
        <td>
          {
            <NumericFormat
              value={chargePerUnit}
              displayType={"text"}
              thousandSeparator={true}
            />
          }
        </td>
      );
    }
  }
}

class QuantityCell extends (GridCell, React.Component) {
  state = {
    input: null,
  };

  handleChange(e) {
    this.setState({ input: e.target.value });
  }

  handleBlur(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });
    if (e.target.value <= 0) {
      toast.error("Quantity Value must be greater then 0");
      return;
    }
    this.setState({ input: "" });
  }

  render() {
    const { inEdit, quantity } = this.props.dataItem;
    const { currentComponent, status } = this.props;

    if (
      (currentComponent === "invoice" && (status === 70 || status == 73)) ||
      inEdit
    ) {
      return (
        <td>
          <NumericFormat
            style={{ width: "125px" }}
            className="some k-textbox"
            inputmode="numeric"
            decimalSeparator="."
            decimalScale="2"
            fixedDecimalScale="true"
            onChange={this.handleChange.bind(this)}
            onBlur={this.handleBlur.bind(this)}
            value={
              this.state.input === null
                ? this.props.dataItem["quantity"]
                : this.state.input
            }
          />

          {/* <Input
            style={{ width: "80px" }}
            type="number"
            onChange={this.handleChange.bind(this)}
            onBlur={this.handleBlur.bind(this)}
            value={
              this.state.input === null
                ? this.props.dataItem["quantity"]
                : this.state.input
            }
          /> */}
        </td>
      );
    } else {
      return (
        <td>
          {
            <NumericFormat
              value={quantity}
              displayType={"text"}
              thousandSeparator={true}
            />
          }
        </td>
      );
    }

    // return (
    //   <td>
    //     {inEdit ? (
    //       <Input
    //         style={{ width: "80px" }}
    //         type="number"
    //         onChange={this.handleChange.bind(this)}
    //         onBlur={this.handleBlur.bind(this)}
    //         value={
    //           this.state.input === null
    //             ? this.props.dataItem["quantity"]
    //             : this.state.input
    //         }
    //       />
    //     ) : (
    //       quantity
    //     )}
    //   </td>
    // );
  }
}

class TariffTypeCell extends (GridCell, React.Component) {
  componentDidMount() {}

  handleChange(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value.text,
    });
  }

  render() {
    const { dataItem, field } = this.props;
    const dataValue = dataItem[field] === null ? "" : dataItem[field];
    const { inEdit, tariffType } = dataItem;

    return (
      <td>
        {inEdit ? (
          <DropDownList
            data={this.props.unitType}
            value={this.props.unitType.find((c) => c.text === dataValue)}
            onChange={this.handleChange.bind(this)}
            textField="text"
          />
        ) : (
          tariffType
        )}
      </td>
    );
  }
}

class ContractedCell extends (GridCell, React.Component) {
  componentDidMount() {}

  handleChange(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });
  }

  render() {
    const { inEdit, contractedYN } = this.props.dataItem;
    return (
      <td>
        {inEdit ? (
          <DropDownList
            data={this.props.contractArray}
            value={this.props.dataItem.contractedYN}
            onChange={this.handleChange.bind(this)}
          />
        ) : (
          contractedYN
        )}
      </td>
    );
  }
}

class ChargeDescriptionCell extends (GridCell, React.Component) {
  componentDidMount() {}

  getFeeCodeDescription(text) {
    const { inEdit } = this.props.dataItem;
    return inEdit
      ? this.props.feeCodeData.find((data) => data["text"] === text)[
          "description"
        ]
      : this.props.feeCodeData.find((data) => data["feeCode"] === text)[
          "description"
        ];
  }

  render() {
    const dataItem = this.props.dataItem.feeCode
      ? this.getFeeCodeDescription(this.props.dataItem.feeCode)
      : "";
    return <td>{dataItem}</td>;
  }
}

class FeeCodeCell extends (GridCell, React.Component) {
  componentDidMount() {}

  handleChange(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value.text,
    });
  }

  handleBlue() {}

  render() {
    const { dataItem, field, currentComponent } = this.props;
    const { inEdit } = dataItem;
    const dataValue = dataItem[field] === null ? "" : dataItem[field];

    return (
      <td>
        {inEdit ? (
          <DropDownList
            data={
              currentComponent === "bid"
                ? this.props.feeCodeData
                : this.props.passThroughFeeCodeData
            }
            textField="text"
            value={
              currentComponent === "bid"
                ? this.props.feeCodeData.find((c) => c.text === dataValue)
                : this.props.passThroughFeeCodeData.find(
                    (c) => c.text === dataValue
                  )
            }
            onChange={this.handleChange.bind(this)}
          />
        ) : (
          dataValue
        )}
      </td>
    );
  }
}

export default InvoiceBidTable;
